import React from 'react';

export interface DotLoaderProps {
    dark?: boolean;
    small?: boolean;
    className?: string;
    color?: string;
    size?: number;
}

export function DotLoader (props: DotLoaderProps= {}) {
    let { size= 6, color } = props;
    const { className, dark, small } = props;

    if (dark) {
        color = 'gray';
    }

    if (small) {
        size = 2;
    }

    return (
        <div className={'dot-loader'}>
            <div style={{ width: size, height: size, backgroundColor: color, color }}
                className='dot-loader--dot dot1' />

            <div style={{ width: size, height: size, backgroundColor: color, color }}
                className='dot-loader--dot dot2' />

            <div style={{ width: size, height: size, backgroundColor: color, color }}
                className='dot-loader--dot dot3' />
        </div>
    );
}

DotLoader.displayName = 'DotLoader';